import { render } from "./Background.vue?vue&type=template&id=4a851204&scoped=true&ts=true"
import script from "./Background.ts?vue&type=script&lang=ts"
export * from "./Background.ts?vue&type=script&lang=ts"

import "./Background.scss?vue&type=style&index=0&id=4a851204&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a851204"]])

export default __exports__